import React from "react";
import { FullScreen } from "../../../assets/styles/GlobalStyle";

const Admin_notification: React.FC = () => {
  return <FullScreen className="container">Admin_Notification</FullScreen>;
};

export default Admin_notification;
